"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DATE: 'YYYY-MM-DD',
    DATETIME: 'YYYY-MM-DD HH:mm',
};
//# sourceMappingURL=formats.js.map